const E="NEXT",o="PREV",t="JUMP",D="DRAG",N="DONE",P=100,R=10,c=3,e=300;export{N as DONE,D as DRAG,t as JUMP,P as MAX_CAROUSEL_SIZE,R as MAX_PARTIAL_SIZE,E as NEXT,c as PARTIAL_RATE,o as PREV,e as SCROLLING_DELAY};
